
import { Injectable, EventEmitter } from '@angular/core';
import { BehaviorSubject, ReplaySubject } from 'rxjs';
import { PersonType } from '../Models/const.personType';

@Injectable({
  providedIn: "root"
})
export class DocumentosObservableService {



  public internalArray: models.DocumentosObservableVM[] = [];

  public notifications: BehaviorSubject<models.DocumentosObservableVM[]> = new BehaviorSubject(null);
  public toDelete: BehaviorSubject<models.DocumentosObservableVM> = new BehaviorSubject(null);

  public toDeleteAll: BehaviorSubject<models.DocumentosObservableVM[]> = new BehaviorSubject(null);
  private isWorkflowSubmited: boolean = false;
  private internalCount: number = 1;
  constructor() {
    //const fakeNotifications: models.DocumentosObservableVM[] = [
    //  {
    //    stepCode: "StepSender",
    //    cardCode: "SenderQualification",
    //    fieldCode: "isLegalRepresentative",
    //    id: 1,
    //    order: null,
    //    ownerCode: "JM",
    //    ownerName: "João Mascarenhas",
    //    path: null,
    //    documentTipologyCode: "Comprovativo de Respresentação Legal"
    //  },
    //  {
    //    stepCode: "StepDeceased",
    //    cardCode: "DeceasedIdentification",
    //    fieldCode: "name",
    //    id: 2,
    //    order: null,
    //    ownerCode: "JM",
    //    ownerName: "João Félix Silva",
    //    path: null,
    //    documentTipologyCode: "Certidão de Nascimento do Falecido"
    //  }, {
    //    stepCode: "StepSender",
    //    cardCode: "SenderQualification",
    //    fieldCode: "isLegalRepresentative",
    //    id: 1,
    //    order: null,
    //    ownerCode: "JM",
    //    ownerName: "João Mascarenhas",
    //    path: null,
    //    documentTipologyCode: "Prova de efectividode"
    //  }, {
    //    stepCode: "StepSender",
    //    cardCode: "SenderQualification",
    //    fieldCode: "isLegalRepresentative",
    //    id: 1,
    //    order: null,
    //    ownerCode: "JM",
    //    ownerName: "Sisto Chaves",
    //    path: null,
    //    documentTipologyCode: "Atestado Junta Freguesia"
    //  },
    //];
    //this.internalArray = fakeNotifications;
    //this.notifications.next(this.internalArray);
  }

  setWorkflowSubmited(workflowSubmited: boolean) {
    this.isWorkflowSubmited = workflowSubmited;
  }

  public removeAllNotifications(): void {
    this.internalArray = [];
    this.toDeleteAll.next([]);
    this.notifications.next(null);
    this.toDelete.next(null);
  }

  public getBeneficiaryByNIF(beneficiaryArray: models.BeneficiaryListVM[], ownerNif: number, ownerName: string = null, ownerCode: string = null): number {
    let beneficiary = null;
    if (ownerCode == "Sender") {
      return PersonType.Sender;
    }
    if (ownerCode == "Deceased") {
      return PersonType.Deceased;
    }
    if (ownerName === null) {
      beneficiary = beneficiaryArray.find(el => el.NIF.toString() == ownerNif.toString());

    } else {
      beneficiary = beneficiaryArray.find(el => el.beneficiaryName.toString() == ownerName.toString());

    }
    return (beneficiary !== undefined && beneficiary !== null) ?
      beneficiary.beneficiaryID :
      null;
  }

  public hasDocWithSameNIF(notification: models.DocumentosObservableVM): boolean {
    const elementsCount = this.internalArray.filter(obj => obj.ownerNif == notification.ownerNif &&
      obj.documentTipologyCode == notification.documentTipologyCode &&
      obj.ownerCode == notification.ownerCode);
    return elementsCount.length > 0;
  }

  public markDocumentExist(doc: models.DocumentosObservableVM) {
    const docIndex = this.internalArray.indexOf(doc);
    if (docIndex > -1) {
      this.internalArray[docIndex].uploaded = true;
      this.notifications.next(this.internalArray);
    } else {
      throw new Error("Document not found in collection!");
    }
  }

 

  public pushNotification(notification: models.DocumentosObservableVM): number {
    const index = this.internalCount++;
    if (this.isWorkflowSubmited == false) {
      let found = this.getExistingNotification(notification);

      if (!!found) {
        found = { ...notification };
      } else {
        notification.id = index;
        this.internalArray.push(notification);
      }
      this.notifications.next(this.internalArray);

    }

    return index;
  }

  public popNotification(notification: models.DocumentosObservableVM): boolean {
    if (this.isWorkflowSubmited == false) {
      let found = this.getExistingNotification(notification);
      if (!!found) {
        const indexOf = this.internalArray.indexOf(found);
        this.internalArray.splice(indexOf, 1);
        this.notifications.next(this.internalArray);
        this.toDelete.next(found);
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  public popNotificationById(id: number): boolean {
    if (this.isWorkflowSubmited == false) {
    let found = this.internalArray.find(el => el.id === id);
    if (!!found) {
      const indexOf = this.internalArray.indexOf(found);
      this.internalArray.splice(indexOf, 1);
      this.notifications.next(this.internalArray);
      this.toDelete.next(found);
      return true;
    } else {
      return false;
      }
    } else {
      return false;
    }
  }
  private getExistingNotification(notification: models.DocumentosObservableVM): models.DocumentosObservableVM {
    const result = this.internalArray.find((el: models.DocumentosObservableVM) => {
      el.stepCode == notification.stepCode &&
        el.cardCode == notification.cardCode &&
        el.fieldCode == notification.fieldCode &&
        el.ownerCode == notification.ownerCode &&
        el.ownerName == notification.ownerName &&
        el.ownerParentCode == notification.ownerParentCode &&
        el.order == notification.order &&
        el.documentTipologyCode == notification.documentTipologyCode &&
        el.documentTipologyDescription == notification.documentTipologyDescription 
    });
    return result;
  }

}
